



















































































































































import Vue from 'vue'
import { DxHtmlEditor, DxToolbar, DxItem, DxTableContextMenu, DxMediaResizing } from 'devextreme-vue/html-editor'
import deMessages from "devextreme/localization/messages/de.json"
import frMessages from "devextreme/localization/messages/fr.json"
import itMessages from "devextreme/localization/messages/it.json"
import { locale, loadMessages } from "devextreme/localization"
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { UiLanguageItem, UiLanguageList } from '@/types'

export interface LanguageDataItem {
  languageId: number
  title: string
  text: string
}

interface LanguageListItem {
  id: number
  code: string
  title: string
  text: string
}

interface ComponentData {
  languageList: LanguageListItem[]
  isTabs: boolean
  tab: number
  areaHeight: number
  sizeValues: any
  fontValues: any
  headerValues: any
  fontSizeOptions: any
  fontFamilyOptions: any
  headerOptions: any
}

export default Vue.extend({
  name: 'LanguagesDialog',

  components: {
    DxHtmlEditor,
    DxMediaResizing,
    DxToolbar,
    DxTableContextMenu,
    DxItem
  },

  props: {
    show: Boolean,
    label: String,
    isRTF: Boolean,
    languagesDialogData: Array as () => LanguageDataItem[],
    titleLabel: {
      type: String,
      default: ""
    },
    textLabel: {
      type: String,
      default: ""
    },
    isTitle: Boolean,
    isTextArea: Boolean,
    defaultTabs: {
      type: Boolean,
      default: false
    }
  },

  data (): ComponentData {
    return {
      languageList: [],
      isTabs: false,
      tab: 0,
      areaHeight: 200,
      sizeValues: ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'],
      fontValues: ['Arial', 'Courier New', 'Georgia', 'Impact', 'Lucida Console', 'Tahoma', 'Times New Roman', 'Verdana'],
      headerValues: [false, 1, 2, 3, 4, 5],
      fontSizeOptions: { inputAttr: { 'aria-label': 'Font size' } },
      fontFamilyOptions: { inputAttr: { 'aria-label': 'Font family' } },
      headerOptions: { inputAttr: { 'aria-label': 'Font family' } },
    }
  },

  watch: {
    isTabs (newVal: boolean): void {
      if (newVal) {
        this.areaHeight = (this.$refs.cardText as HTMLElement).clientHeight - 72 - 56
      }
    },
  },

  computed: {
    uiLanguageList (): UiLanguageList {
      return this.$store.state.uiLanguageList
    },

    selectedLanguageCode (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }
  },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onCancelButtonClick (): void {
      this.$emit('close')
    },

    onSaveButtonClick (): void {
      this.$emit('save', this.languageList.map((item: LanguageListItem) => {
        return { languageId: item.id, title: item.title, text: item.text }
      }))
    }
  },

  created (): void {
    loadMessages(deMessages)
    loadMessages(frMessages)
    loadMessages(itMessages)
    locale(this.selectedLanguageCode)
  },

  mounted () {
    this.isTabs = this.defaultTabs

    this.languageList = this.uiLanguageList.map((item: UiLanguageItem) => {
      return {id: item.syzId ,code: item.code, title: '', text: ''}
    })

    this.languagesDialogData.forEach((item: LanguageDataItem) => {
      let foundItem: LanguageListItem | undefined = this.languageList.find((i: LanguageListItem) => i.id === item.languageId)
      if(foundItem) {
        foundItem.title = item.title ? item.title : ''
        foundItem.text = item.text ? item.text : ''
      }
    })

    setTimeout(() => {
      const focusedField: any = this.$refs['focusedField']
      if (focusedField && focusedField[0]) {
        focusedField[0].focus()
      }
    }, 0)

    const app: any = document.getElementById("app")
    if(app) {
      app.style.zIndex = 500
    }
  },

  beforeDestroy (): void {
    const app: any = document.getElementById("app")
    if(app) {
      app.style.zIndex = ''
    }
  }
})
